import { Injectable } from '@angular/core';
import { DbService } from './idb.service';
import { RefundModel } from 'src/app/models/refund.model';
import { from, Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ReturnDbService {

  constructor(private dbService: DbService) { }

  public async getCommitedReturns(): Promise<RefundModel[] | undefined> {

    return this.dbService.getAllFromIndex('returns', 'by-status', 2)

  }

  getReturntsByDate(dt1: Date, dt2: Date | undefined) {
    const keyRange = IDBKeyRange.bound(dt1, dt2);
    return this.dbService.getAllFromIndex('returns', 'by-date', keyRange)
  }

  createRefund(doc: RefundModel): Observable<RefundModel> {

    doc.id = uuidv4();
    const prom = this.dbService.add('returns', doc)
    return from(prom)
  }

  commitRefund(refund: RefundModel, toStatus: number) {
    //пока без проверок
    refund.statusId = toStatus;
    return this.dbService.update('returns', refund)
  }

  getRefund(id:string){
    return this.dbService.get('returns', id)
  }

  updRefund(refund: RefundModel){
    if (!refund.items) {
      refund.items = []
    }

    refund.totalAmount = 0
    refund.summa = 0

    refund.items.forEach(item => {
      refund.totalAmount += item.amount
      refund.summa += +(item.amount * item.price)
    })
    return this.dbService.update('returns', refund)
  }

}
